export const LIST_SPECIAL_DEAL = 'LIST_SPECIAL_DEAL'
export const CREATE_SPECIAL_DEAL = 'CREATE_SPECIAL_DEAL'
export const REMOVE_SPECIAL_DEAL = 'REMOVE_SPECIAL_DEAL'
export const DETAIL_SPECIAL_DEAL = 'DETAIL_SPECIAL_DEAL'
export const TOTAL_SPECIAL_DEAL = 'TOTAL_SPECIAL_DEAL'
